var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"buildingTag",staticClass:"building-tag",class:{
		active: _vm.isCategoryEnabled(_vm.category),
		disabled: _vm.isCategoryDisabled(_vm.category)
	},style:({ left: _vm.coordsX + 'px', top: _vm.coordsY + 'px' })},[_c('svgicon',{attrs:{"name":`expenseCategories/${_vm.category.assetName}`}}),_c('span',[_vm._v(_vm._s(_vm.category.name))]),(_vm.isCategoryDisabled(_vm.category))?_c('div',{staticClass:"status-tag disabled"},[_c('svgicon',{attrs:{"name":"lock"}})],1):(
			_vm.category.isCompletedForCurrentStudent || _vm.isCategoryBudgeted(_vm.category)
		)?_c('div',{staticClass:"status-tag completed"},[_c('svgicon',{attrs:{"name":"check"}})],1):_vm._e(),_c('div',{staticClass:"tag-pointer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }